function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "o-icon__path",
  d: "M46.55,14.55H3.45a3.45,3.45,0,1,1,0-6.9h43.1a3.45,3.45,0,1,1,0,6.9Z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "o-icon__path",
  d: "M46.55,27.69H3.45a3.45,3.45,0,0,1,0-6.9h43.1a3.45,3.45,0,1,1,0,6.9Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "o-icon__path",
  d: "M46.55,40.84H3.45a3.45,3.45,0,0,1,0-6.9h43.1a3.45,3.45,0,0,1,0,6.9Z"
});

var SvgBurger = function SvgBurger(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    className: "o-icon"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCIgY2xhc3M9Im8taWNvbiI+CiAgPHBhdGggY2xhc3M9Im8taWNvbl9fcGF0aCIgZD0iTTQ2LjU1LDE0LjU1SDMuNDVhMy40NSwzLjQ1LDAsMSwxLDAtNi45aDQzLjFhMy40NSwzLjQ1LDAsMSwxLDAsNi45WiIvPgogIDxwYXRoIGNsYXNzPSJvLWljb25fX3BhdGgiIGQ9Ik00Ni41NSwyNy42OUgzLjQ1YTMuNDUsMy40NSwwLDAsMSwwLTYuOWg0My4xYTMuNDUsMy40NSwwLDEsMSwwLDYuOVoiLz4KICA8cGF0aCBjbGFzcz0iby1pY29uX19wYXRoIiBkPSJNNDYuNTUsNDAuODRIMy40NWEzLjQ1LDMuNDUsMCwwLDEsMC02LjloNDMuMWEzLjQ1LDMuNDUsMCwwLDEsMCw2LjlaIi8+Cjwvc3ZnPgo=";
export { SvgBurger as ReactComponent };